import { render, staticRenderFns } from "./EditContact.vue?vue&type=template&id=5143160b&scoped=true"
import script from "./EditContact.vue?vue&type=script&lang=js"
export * from "./EditContact.vue?vue&type=script&lang=js"
import style0 from "./EditContact.vue?vue&type=style&index=0&id=5143160b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143160b",
  null
  
)

export default component.exports